import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  translatedData: {},
  languageCode: "en",
};

const languageSlice = createSlice({
  name: "language",
  initialState,
  reducers: {
    setTranslatedData: (state, action) => {
      state.translatedData = action.payload;
    },

    clearTranslatedData: (state) => {
      state.translatedData = {};
    },
    setLanguageCode: (state, action) => {
      state.languageCode = action.payload;
    },
  },
});

export const { setTranslatedData, clearTranslatedData, setLanguageCode } =
  languageSlice.actions;
export default languageSlice.reducer;
